<script>
export default {
  // If the page is not found, just redirect to the overview page
  created() {
    this.$router.push("/");
  },
};
</script>

<template>
  <div></div>
</template>
